import { InjectionToken } from '@angular/core';

import { QueryServiceConfig } from '@relevance/angular-core';

/**
 * Interface for the search service configuration.
 */
export interface SearchServiceConfig {
  queryConfig: QueryServiceConfig;
  rateThreshold?: number;
  countThreshold?: number;
  queryName?: string;
  autoContext?: boolean;
  forceMode?: 'filter'|'boost'|'mixed';
  stackCount?: number;
  forceSlice?: boolean;
  defaultSlice?: number;
}

/**
 * This injection token can be used to inject the query API configuration.
 */
export const SEARCH_CONFIG = new InjectionToken<SearchServiceConfig>('search.config');
